import { setAudioOutputDevice } from '../../../react/features/base/devices/actions.web';
import { updateSettings } from '../../../react/features/base/settings/actions';
export function setXbeesSelectedDevices({ getState, dispatch }) {
    // @ts-ignore
    const { selectedMicrophoneDeviceId, selectedSpeakerDeviceId, selectedVideoDeviceId, isXbees } = config;
    if (!isXbees) {
        return;
    }
    const state = getState();
    const availableDevices = state['features/base/devices'].availableDevices;
    const { userSelectedMicDeviceId, userSelectedAudioOutputDeviceId, userSelectedCameraDeviceId } = state['features/base/settings'];
    const selectedDevices = {};
    if (selectedMicrophoneDeviceId
        && selectedMicrophoneDeviceId !== userSelectedMicDeviceId
        && availableDevices.audioInput?.some(d => d.deviceId === selectedMicrophoneDeviceId)) {
        selectedDevices.userSelectedMicDeviceId = selectedMicrophoneDeviceId;
    }
    if (selectedSpeakerDeviceId
        && selectedSpeakerDeviceId !== userSelectedAudioOutputDeviceId
        && availableDevices.audioOutput?.some(d => d.deviceId === selectedSpeakerDeviceId)) {
        selectedDevices.userSelectedAudioOutputDeviceId = selectedSpeakerDeviceId;
        dispatch(setAudioOutputDevice(selectedSpeakerDeviceId));
    }
    if (selectedVideoDeviceId
        && selectedVideoDeviceId !== userSelectedCameraDeviceId
        && availableDevices.videoInput?.some(d => d.deviceId === selectedVideoDeviceId)) {
        selectedDevices.userSelectedCameraDeviceId = selectedVideoDeviceId;
    }
    dispatch(updateSettings(selectedDevices));
}
